import { render, staticRenderFns } from "./VueDropzone.vue?vue&type=template&id=39c1919c&scoped=true&"
import script from "./VueDropzone.vue?vue&type=script&lang=js&"
export * from "./VueDropzone.vue?vue&type=script&lang=js&"
import style0 from "./VueDropzone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VueDropzone.vue?vue&type=style&index=1&id=39c1919c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1919c",
  null
  
)

export default component.exports